import { inject } from 'mobx-react';
import { getExpenseFormLabel } from '../../../utils/expense-form-labels';

const MileageInput = ({ data, distance, onUpdate }) => {
  const handleChange = (e) => {
    onUpdate(e.target.value);
  };

  return (
    <div className='d-flex pb-2'>
      <div className='report-label col-2'>{getExpenseFormLabel(data, 'field_mileage')}</div>
      <div className='col-8'>
        <input
          className='form-control'
          placeholder={data.t.read('review_expense.mileage.placeholder')}
          value={distance || ''}
          type='number'
          name='distance'
          data-testid='mileage-input'
          onChange={handleChange}
          step='1'
          min='0'
        />
      </div>
    </div>
  );
};

export default inject('data')(MileageInput);
